import { Component } from '@angular/core';
import { Collaboration } from '../../../../models';
import { StatusEnum } from '../../../../shared/utils/enums';


@Component({
  selector: 'app-ancienne-collab',
  templateUrl: './ancienne-collab.component.html',
  styleUrl: './ancienne-collab.component.scss',
})
export class AncienneCollabComponent {
   StatusEnum =  StatusEnum

  randomData: Collaboration[] = [
    {
      location: 'NovaCare Lyon',
      missionName: 'Mission A',
      date: 'du 01 jan 2024 au 15 jan 2024',
      status: StatusEnum.PENDING,
    },
    {
      location: 'NovaCare Paris',
      missionName: 'Mission A',
      date: 'du 01 jan 2024 au 15 jan 2024',
      status: StatusEnum.VALIDATED
    },
    {
      location: 'NovaCare Paris',
      missionName: 'Mission A',
      date: 'du 01 jan 2024 au 15 jan 2024',
      status: StatusEnum.VALIDATED
    },
    {
      location: 'NovaCare Paris',
      missionName: 'Mission A',
      date: 'du 01 jan 2024 au 15 jan 2024',
      status: StatusEnum.VALIDATED
    },
    {
      location: 'NovaCare Paris',
      missionName: 'Mission A',
      date: 'du 01 jan 2024 au 15 jan 2024',
      status: StatusEnum.VALIDATED
    },
    
  ];
}
